// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3VETZ","consentsList":"PatientConsents_consentsList__2Nk6X","consentsListEmpty":"PatientConsents_consentsListEmpty__38hvU"};